import { Controller } from '@hotwired/stimulus'

const TODOS = 'todos'

/*
 * Filtros por ramo de «Seguros de <aseguradora>» en la ficha de la aseguradora
 * (`Opinables::SegurosAseguradoraComponent`).
 *
 * Ocultan los demás ramos en el navegador: todos los seguros van siempre en el
 * HTML, para que el buscador vea los enlaces a sus fichas. El filtro guarda en
 * `data-ramo` el id del bloque que muestra. El «Ver N más» de cada ramo es
 * cosa de `revelar-progresivo`.
 */
export default class extends Controller {
  static targets = ['filtro', 'ramo']

  filtra (event) {
    const elegido = event.currentTarget.dataset.ramo

    this.filtroTargets.forEach(filtro => {
      filtro.setAttribute('aria-pressed', filtro.dataset.ramo === elegido)
    })
    this.ramoTargets.forEach(ramo => {
      ramo.hidden = elegido !== TODOS && ramo.id !== elegido
    })
  }
}
